module.exports = __webpack_public_path__ + "static/media/captions_Wharfdale.c3923132.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Wharfdale.vtt
// module id = 126
// module chunks = 0